import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsvfileService } from '../../service/msvfile.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UploadXmlFileService } from '../../service/upload-xml-file.service';

@Component({
  selector: 'app-complete-data',
  templateUrl: './complete-data.component.html',
  styleUrls: ['./complete-data.component.css']
})
export class CompleteDataComponent implements OnInit {

  fileId: number = null;
  msgs: any[] = [];
  dataResult: any = {
    Errors: [],
    Warnings: [],
    DataCompletitionsErrors: [],
    DataCompletitions: [],
    MSVFileName: '' as string,
  };
  listBank: any[] = [];

  cols: any[];
  constructor(private route: ActivatedRoute, private dataService: MsvfileService, private addDataService: UploadXmlFileService, private router: Router) { }

  ngOnInit() {
    this.msgs = [];
    const param = Number.parseInt(this.route.snapshot.paramMap.get('id'));
    if (param && param > 0) {
      this.fileId = param;
      this.dataService.prepareData(this.fileId).subscribe((result: any) => {
        this.dataResult = result
        this.setDateFormat();
        //this.setOriginals();
      }, (error: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת נתונים להשלמה');
      });
    } else {
      this.showMessage('error', '', 'תקלה לא צפויה. עובר בחזרה למסך טיוטות בהמתנה');
      setTimeout(() => {
        this.router.navigate(['/MSV-file-list']);
      }, 1500);
    }

    this.cols = [
      { field: 'KupaName', header: 'שם הקופה' },
      { field: 'MisparKupaBeOtzar', header: 'מספר קופה באוצר' },
      { field: 'GufMosdi', header: 'ח.פ הגוף המוסדי' },
      { field: 'ShemBankMasik', header: 'בנק מעסיק' },
      { field: 'MISPAR_SNIF_MAASIK', header: 'סניף מעסיק' },
      { field: 'MISPAR_CHESHBON_MAASIK', header: 'חשבון מעסיק' },
      { field: 'ShemBankKolet', header: 'בנק קולט' },
      { field: 'MISPAR_BANK_KOLET', header: 'מספר בנק קולט' },
      { field: 'MISPAR_SNIF_KOLET', header: 'מספר סניף קולט' },
      { field: 'MISPAR_CHESHBON_KOLET', header: 'מספר חשבון קולט' },
      // { field: 'ShemBank', header: 'שם הבנק' },
      { field: 'SACH_HAFKADA_KUPA_H_P', header: 'סך הפקדה' },
      { field: 'MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM', header: 'אסמכתא' },
      { field: 'TAARICH_ERECH_HAFKADA_LEKUPA', header: 'תאריך ערך' }
    ];

    this.addDataService.getBankAsStrings().subscribe((result: any) => {
        this.listBank = result;
        this.listBank.unshift({ label: 'בחירת בנק', value: null });
      },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת בנקים ');
      }
    );
  }

  showMessage(type, summaryMessage, message): void {
    //this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message, life: 10000 });
  }

  onSubmit(): void {
    this.msgs = [];
    this.setDateFormat();
    this.dataService.setDataCompletitions(this.dataResult).subscribe((result: any) => {
      this.dataResult = result;
      this.setDateFormat();
      //this.setOriginals();
      if (this.dataResult.Errors.length === 0 && this.dataResult.DataCompletitions.length === 0 && this.dataResult.DataCompletitionsErrors.length === 0) {
        this.showMessage('success', '', 'שודר בהצלחה');
        this.dataResult.Warnings = null;
        setTimeout(() => {
          this.router.navigate(['MSV-file-list']); // ???
        }, 1500);
      }
      else if (this.dataResult.Errors.length === 0 && ((this.dataResult.DataCompletitions.length > 0) || this.dataResult.DataCompletitionsErrors.length > 0)) {
        this.showMessage('error', '', 'נדרשת בדיקה עבור הנתונים');
      }
      else if (this.dataResult.Errors.length > 0) {
        this.showMessage('error', '', 'נמצאו נתונים לא תקינים');
      }
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'קיימת תקלה בשמירה');
    });
  }

  setDateFormat(): void {
    let date: Date = new Date();
    for (let i = 0; i < this.dataResult.DataCompletitions.length; i++) {
      if (this.dataResult.DataCompletitions[i].TAARICH_ERECH_HAFKADA_LEKUPA) {
        date = new Date(Date.parse(this.dataResult.DataCompletitions[i].TAARICH_ERECH_HAFKADA_LEKUPA));
        this.dataResult.DataCompletitions[i].TAARICH_ERECH_HAFKADA_LEKUPA_Formatted = date.toDateString();
        this.dataResult.DataCompletitions[i].TAARICH_ERECH_HAFKADA_LEKUPA = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 22, 0, 0);
      }
    }
  }

  // setOriginals() {
  //   this.dataResult.DataCompletitions.forEach(f => {
  //     f.originalShemBankMasik = f.ShemBankMasik;
  //     f.originalMISPAR_BANK_MAASIK = f.MISPAR_BANK_MAASIK;
  //     f.originalMISPAR_SNIF_MAASIK = f.MISPAR_SNIF_MAASIK;
  //     f.originalMISPAR_CHESHBON_MAASIK = f.MISPAR_CHESHBON_MAASIK;
  //   });
  // }

  // copyingRecords(): void {
  //   let cnt = 0;
  //   let date: Date = new Date();
  //   for (let i = 0; i < this.dataResult.DataCompletitions.length; i++) {
  //     this.dataResult.DataCompletitions[i].MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM = this.dataResult.DataCompletitions[0].MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM;
  //     if (this.dataResult.DataCompletitions[0].TAARICH_ERECH_HAFKADA_LEKUPA) {
  //       date = new Date(Date.parse(this.dataResult.DataCompletitions[0].TAARICH_ERECH_HAFKADA_LEKUPA));
  //       this.dataResult.DataCompletitions[i].TAARICH_ERECH_HAFKADA_LEKUPA_Formatted = date.toDateString();
  //       this.dataResult.DataCompletitions[i].TAARICH_ERECH_HAFKADA_LEKUPA = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 22, 0, 0);
  //     }
  //     cnt++;
  //   }
  //   if (cnt === this.dataResult.DataCompletitions.length) {
  //     this.showMessage('success', '', 'בוצע העתקה לכל הרשומות');
  //   }
  //   else if (cnt !== this.dataResult.DataCompletitions.length && cnt > 0) {
  //     this.showMessage('success', '', 'בוצע העתקה חלקית');
  //   }
  //   else {
  //     this.showMessage('error', '', 'שגיאה בהעתקת רשומות. שדה תאריך ערך הינו חובה');
  //   }
  // }


  copyingRecords(): void {
    this.msgs = [];
    let cntA = 0;
    let cntB = 0;
    let cnt000 = 0;
    let date: Date = new Date();
    for (let i = 0; i < this.dataResult.DataCompletitions.length; i++) {
      if (this.dataResult.DataCompletitions[0].MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM) {
        this.dataResult.DataCompletitions[i].MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM = this.dataResult.DataCompletitions[0].MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM;
        cntA++;
      }
      if (this.dataResult.DataCompletitions[0].TAARICH_ERECH_HAFKADA_LEKUPA) {
        date = new Date(Date.parse(this.dataResult.DataCompletitions[0].TAARICH_ERECH_HAFKADA_LEKUPA));
        this.dataResult.DataCompletitions[i].TAARICH_ERECH_HAFKADA_LEKUPA_Formatted = date.toDateString();
        this.dataResult.DataCompletitions[i].TAARICH_ERECH_HAFKADA_LEKUPA = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 22, 0, 0);
        cntB++;
      }
    }
    if (this.dataResult.DataCompletitions.length > 0) {
      for (let i = 0; i < this.dataResult.DataCompletitions.length; i++) {
        if (!this.dataResult.DataCompletitions[i].SACH_HAFKADA_KUPA_H_P || this.dataResult.DataCompletitions[i].SACH_HAFKADA_KUPA_H_P == 0) {
          this.dataResult.DataCompletitions[i].MISPAR_ASMACHTA_LEAHAVARAT_KSAFIM = '000';
          cnt000++;
        } 
      }
    } 
    if (cntA === this.dataResult.DataCompletitions.length && cntB === this.dataResult.DataCompletitions.length) {
      this.showMessage('success', '', 'בוצע הזנה של אסמכתא ותאריך ערך לכל הרשומות');
    } else if ((cntA > 0) || (cntB > 0)) {
      this.showMessage('warn', '', 'בוצע הזנה חלקית');
    } else if (cntA === 0 && cntB === 0) {
      this.showMessage('error', '', 'שגיאה בהזנת אסמכתא ותאריך ערך');
    } else {
      this.showMessage('error', '', 'שגיאה בהזנת אסמכתא ותאריך ערך');
    }
    if (cnt000 > 0) {
      this.showMessage('warn', '', 'בוצעה הזנה של אסמכתא 000 עבור ' + cnt000.toString() + ' קופות');
    }
  }

  copyingBankDetails() {

    if (this.dataResult.DataCompletitions.length==0) {
      this.showMessage('error', '', 'אין קופות להעתקה');
      return;
    } else if (this.dataResult.DataCompletitions.length==1) {
      this.showMessage('error', '', 'אין קופות להעתקה אליהן את פרטי הבנק - קיימת קופה אחת בלבד');
      return;
    }
    if (!this.dataResult.DataCompletitions[0].MISPAR_BANK_MAASIK || this.dataResult.DataCompletitions[0].MISPAR_BANK_MAASIK == '' || this.dataResult.DataCompletitions[0].MISPAR_BANK_MAASIK.toString() == '0') {
      this.showMessage('error', '', 'לא נבחר בנק מעסיק בקופה הראשונה');
      return;
    }
    if (!this.dataResult.DataCompletitions[0].MISPAR_SNIF_MAASIK || this.dataResult.DataCompletitions[0].MISPAR_SNIF_MAASIK == '') {
      this.showMessage('error', '', 'לא נבחר סניף מעסיק בקופה הראשונה');
      return;
    }
    if (!this.dataResult.DataCompletitions[0].MISPAR_CHESHBON_MAASIK || this.dataResult.DataCompletitions[0].MISPAR_CHESHBON_MAASIK == '') {
      this.showMessage('error', '', 'לא נבחר חשבון מעסיק בקופה הראשונה');
      return;
    }

    for (let i = 0; i < this.dataResult.DataCompletitions.length; i++) {
      this.dataResult.DataCompletitions[i].MISPAR_BANK_MAASIK = this.dataResult.DataCompletitions[0].MISPAR_BANK_MAASIK;
      this.dataResult.DataCompletitions[i].MISPAR_SNIF_MAASIK = this.dataResult.DataCompletitions[0].MISPAR_SNIF_MAASIK;
      this.dataResult.DataCompletitions[i].MISPAR_CHESHBON_MAASIK = this.dataResult.DataCompletitions[0].MISPAR_CHESHBON_MAASIK;
      
    }
    
    this.showMessage('success', '', 'בוצע הזנה של פרטי בנק מעסיק לכל הרשומות');
    
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/MSVFile/complete-data/complete-data.component.ts